/* Kalkkartan — Sveriges 290 kommuner färgade efter uppmätt totalhårdhet.
   Data: assets/svp-kalkkarta-data.js (window.SVP_KALK), genererad ur SGU:s
   öppna grundvattenkemi. Se docs/KALKKARTA.md.

   Sidan fungerar UTAN den här filen: tabellen med alla 290 kommuner ligger i
   HTML:en (snippets/svp-kalkkarta-tabell.liquid). Kartan är ett tillägg ovanpå,
   inte sidans enda innehåll — annars hade en besökare utan JavaScript, och en
   sökmotor som inte kör det, sett en tom sida. */
(function () {
  'use strict';

  var D = window.SVP_KALK;
  // Sidan bygger på Kunskapsbankens skelett (article.svp-faq-wrapper), så
  // kartans egen behållare är svg:n – inte ett eget wrapper-id.
  var rot = document.getElementById('svp-kalk-svg');
  if (!rot) return;
  if (!D) {
    // Datafilen kom inte fram. Lämnas ramverket kvar står en tom kartruta,
    // en sökruta som inte svarar och ett tomt kort — det ser ut som en
    // trasig sida. Tabellen med alla 290 kommuner står kvar i HTML:en.
    var yta = document.getElementById('svp-kalk-yta');
    if (yta) {
      yta.hidden = true;
      var p = document.createElement('p');
      p.className = 'ingen-data';
      p.textContent = 'Kartan kunde inte laddas just nu. Tabellen med alla '
        + '290 kommuner längre ner på sidan fungerar ändå.';
      yta.parentNode.insertBefore(p, yta);
    }
    return;
  }

  // Samma band som i scripts/bygg_kalkkarta.py. Bara den översta gränsen är en
  // myndighetssiffra: Livsmedelsverkets riktvärde för totalhårdhet är 15 °dH,
  // "tjänligt med anmärkning". Orden under är beskrivande.
  var BAND = [
    { tak: 2,     klass: 'b1', namn: 'Mycket mjukt' },
    { tak: 5,     klass: 'b2', namn: 'Mjukt' },
    { tak: 10,    klass: 'b3', namn: 'Medelhårt' },
    { tak: 15,    klass: 'b4', namn: 'Hårt' },
    { tak: 1e9,   klass: 'b5', namn: 'Mycket hårt – över riktvärdet' }
  ];
  var RIKTVARDE = 15;

  function band(dh) {
    for (var i = 0; i < BAND.length; i++) if (dh <= BAND[i].tak) return BAND[i];
    return BAND[BAND.length - 1];
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function tal(v) { return String(v).replace('.', ','); }

  // 121 av 290 kommunnamn innehåller å, ä eller ö, och 23 BÖRJAR med ett.
  // Utan veckning svarade sökningen "Ingen kommun heter så" på orebro, malmo
  // och angelholm — precis det man skriver på en telefon i en brådska.
  function veck(s) {
    s = String(s).toLowerCase();
    if (s.normalize) s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return s.replace(/å/g, 'a').replace(/ä/g, 'a').replace(/ö/g, 'o')
            .replace(/é/g, 'e').replace(/ü/g, 'u');
  }
  function el(id) { return document.getElementById(id); }

  var koder = Object.keys(D.kommuner).sort(function (a, b) {
    return D.kommuner[a].namn.localeCompare(D.kommuner[b].namn, 'sv');
  });
  var vald = null;

  /* ---------------------------------------------------------------- kartan */
  var svg = el('svp-kalk-svg');
  svg.setAttribute('viewBox', '0 0 ' + D.bredd + ' ' + D.hojd);
  var bitar = [];
  for (var i = 0; i < koder.length; i++) {
    var k = koder[i], r = D.kommuner[k];
    var b = r.dh == null ? null : band(r.dh);
    bitar.push('<path class="kom ' + (b ? b.klass : 'tom') + '" data-k="' + k
      + '" role="button" tabindex="0" aria-label="' + esc(r.namn) + ' kommun, '
      + (b ? tal(r.dh) + ' grader dH, ' + esc(b.namn).toLowerCase()
           : 'för få brunnsprov') + '" d="' + r.d + '"></path>');
  }
  el('svp-kalk-lan').innerHTML = bitar.join('');

  function ritaKarta() {
    var p = svg.querySelectorAll('path.kom');
    for (var i = 0; i < p.length; i++) {
      p[i].classList.toggle('vald', p[i].getAttribute('data-k') === vald);
    }
    var etikett = '';
    if (vald) {
      var r = D.kommuner[vald];
      etikett = '<text class="etikett" x="' + r.mitt[0] + '" y="' + r.mitt[1]
        + '" text-anchor="middle">' + esc(r.namn) + '</text>';
    }
    el('svp-kalk-etiketter').innerHTML = etikett;
  }

  /* ----------------------------------------------------------------- kortet */
  function ritaKort() {
    var host = el('svp-kalk-kort');
    if (!vald) {
      host.innerHTML = '<p class="valj">Klicka på en kommun i kartan, eller sök i '
        + 'rutan nedan, så visas hur hårt brunnsvattnet är uppmätt där.</p>';
      return;
    }
    var r = D.kommuner[vald];
    if (r.dh == null) {
      host.innerHTML = '<h3>' + esc(r.namn) + '</h3>'
        + '<p class="stor tunn">För få brunnsprov</p>'
        + '<p class="bandnamn"><span class="prick tom"></span>Ingen färg på kartan</p>'
        + '<p>SGU:s öppna mätningar räcker inte för att säga något om '
        + esc(r.namn) + '. ' + (r.n ? 'Det finns ' + r.n + ' prov härifrån, och under tre '
          + 'prov målar vi hellre ingenting än en färg som vilar på ett enda analysbesked.'
          : 'Det finns inga brunnsprov alls härifrån i materialet.')
        + '</p><p>Hårdheten i en enskild brunn avgörs ändå av berggrunden just '
        + 'där — ett <a href="/collections/vattenanalys">vattenprov</a> är det enda '
        + 'som ger ditt eget värde.</p>';
      return;
    }
    var b = band(r.dh);
    // Spannet är 10:e och 90:e percentilen. Under tio prov ÄR de bara minsta
    // och största värdet, och "nio av tio prov" vore ett påstående om en
    // fördelning som inte finns. Då skrivs spannet som det är i stället.
    var spann = '';
    if (r.lag != null && r.hog != null && r.hog > r.lag) {
      spann = r.n >= 10
        ? '<p class="spann">Nio av tio prov ligger mellan <b>' + tal(r.lag) + '</b> och <b>'
          + tal(r.hog) + ' °dH</b> — skillnaden mellan två brunnar i samma kommun kan '
          + 'alltså vara stor.</p>'
        : '<p class="spann">De ' + r.n + ' proven spänner från <b>' + tal(r.lag)
          + '</b> till <b>' + tal(r.hog) + ' °dH</b> — för få för att säga mer än att '
          + 'skillnaden mellan två brunnar kan vara stor.</p>';
    }
    host.innerHTML = '<h3>' + esc(r.namn) + '</h3>'
      + '<p class="stor">' + tal(r.dh) + ' °dH</p>'
      + '<p class="bandnamn"><span class="prick ' + b.klass + '"></span>' + esc(b.namn) + '</p>'
      + '<dl class="fakta">'
      + '<dt>Underlag</dt><dd>' + r.n + ' brunnsprov'
      + (r.ar ? ', ' + r.ar[0] + '–' + r.ar[1] : '')
      + (r.borr ? ' (varav ' + r.borr + ' bergborrade)' : '') + '</dd>'
      + '<dt>Riktvärde</dt><dd>15 °dH — ' + (r.dh > RIKTVARDE
          ? 'medianen här <b>ligger över</b> Livsmedelsverkets riktvärde'
          : 'medianen här ligger under Livsmedelsverkets riktvärde') + '</dd>'
      + '</dl>' + spann
      + '<p class="rad">' + esc(rad(r.dh)) + '</p>'
      + '<p style="margin:0"><a class="cta-button" href="/collections/vattenanalys">'
      + 'Mät hårdheten i din egen brunn →</a></p>';
  }

  // Mjukt vatten är inte automatiskt "bra" vatten. SGU:s bedömningsgrunder:
  // mellan 20 och 60 mg kalcium per liter (ungefär 3–8 °dH) minskar risken för
  // korrosion i ledningar. Riktigt mjukt vatten är alltså mer aggressivt mot
  // rören, och det är inget en kalkkarta brukar säga.
  function rad(dh) {
    if (dh > 15) return 'Över riktvärdet: räkna med kalkavlagringar i varmvattenberedare, '
      + 'blandare och diskmaskin. Ett avhärdningsfilter är det som hjälper.';
    if (dh > 10) return 'Hårt vatten. Kalkfläckar och avlagringar märks, särskilt där '
      + 'vattnet värms upp, men värdet ligger under Livsmedelsverkets riktvärde.';
    if (dh > 5) return 'Medelhårt. De flesta märker varken av kalk eller korrosion.';
    if (dh > 2) return 'Mjukt vatten. Ingen kalk att tala om — men mjukt vatten är mer '
      + 'aggressivt mot ledningar, så koppar och andra metaller är värda att hålla koll på.';
    return 'Mycket mjukt vatten. Kalk är inte problemet här; däremot är vattnet '
      + 'korrosivt, och metaller från rören kan lösas ut. Kontrollera pH, alkalinitet '
      + 'och koppar.';
  }

  /* ------------------------------------------------------------------ sökning */
  function ritaTraffar() {
    var q = veck(el('svp-kalk-sok').value.trim());
    var lista = el('svp-kalk-traffar');
    if (!q) { lista.innerHTML = ''; lista.hidden = true; return; }
    var ut = [];
    for (var i = 0; i < koder.length && ut.length < 8; i++) {
      var r = D.kommuner[koder[i]];
      if (veck(r.namn).indexOf(q) !== 0) continue;
      ut.push('<button type="button" data-k="' + koder[i] + '">' + esc(r.namn)
        + '<span>' + (r.dh == null ? 'för få prov' : tal(r.dh) + ' °dH') + '</span></button>');
    }
    if (!ut.length) {
      for (var j = 0; j < koder.length && ut.length < 8; j++) {
        var s = D.kommuner[koder[j]];
        if (veck(s.namn).indexOf(q) < 1) continue;
        ut.push('<button type="button" data-k="' + koder[j] + '">' + esc(s.namn)
          + '<span>' + (s.dh == null ? 'för få prov' : tal(s.dh) + ' °dH') + '</span></button>');
      }
    }
    lista.innerHTML = ut.length ? ut.join('')
      : '<p class="ingen">Ingen kommun heter så.</p>';
    lista.hidden = false;
  }

  function valj(kod, franKartan) {
    vald = (vald === kod) ? null : kod;
    ritaKarta();
    ritaKort();
    // På mobil ligger svaret ovanför kartan. Klickar man i kartan hamnar
    // svaret utanför skärmen, och det ser ut som om ingenting hände.
    if (vald && franKartan && window.innerWidth < 900) {
      var mjuk = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      el('svp-kalk-kort').scrollIntoView({ block: 'nearest',
        behavior: mjuk ? 'smooth' : 'auto' });
    }
  }

  /* ----------------------------------------------------------------- koppling */
  svg.addEventListener('click', function (e) {
    var p = e.target.closest && e.target.closest('path.kom');
    if (p) valj(p.getAttribute('data-k'), true);
  });
  svg.addEventListener('keydown', function (e) {
    var p = e.target.closest && e.target.closest('path.kom');
    if (p && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); valj(p.getAttribute('data-k'), true); }
  });
  el('svp-kalk-sok').addEventListener('input', ritaTraffar);
  el('svp-kalk-traffar').addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button[data-k]');
    if (!b) return;
    vald = null;
    valj(b.getAttribute('data-k'));
    el('svp-kalk-traffar').hidden = true;
    el('svp-kalk-sok').value = D.kommuner[b.getAttribute('data-k')].namn;
  });

  // Siffrorna i ingressen skrivs av datan, inte för hand: ett påstående om
  // antal prov som ligger kvar efter nästa omkörning är ett felaktigt påstående.
  var fakta = el('svp-kalk-fakta');
  if (fakta) {
    fakta.textContent = D.prov.toLocaleString('sv-SE') + ' brunnsprov från '
      + D.med_varde + ' av 290 kommuner' + (D.ar ? ', ' + D.ar[0] + '–' + D.ar[1] : '')
      + '. Riksmedianen är ' + tal(D.riksmedian) + ' °dH.'
      + (D.byggd ? ' Underlaget hämtades ' + D.byggd + '.' : '');
  }

  ritaKarta();
  ritaKort();
})();
